export default "__VITE_ASSET__cfb854dc__"